import {
    AppIdentifiers,
    IOpenBankingSpecificParams,
    IPerformActionTopicPayload,
    ProductPackageToID
} from "@sparkware/uc-sdk-core";
import {
    getCasinofiedCommonAppContextParams,
    getCasinofiedDeviceInfo,
    getCasinofiedGeoInfoParams
} from "../../casinofied-helper-functions";
import {ActionHandlerBase} from "../action-handler-base";


export class OpenBankingActionHandler extends ActionHandlerBase {
    async handle(payload: IPerformActionTopicPayload): Promise<void> {
        const openBakingSpecificParams: IOpenBankingSpecificParams = (payload.launchInfo.appSpecificParameters || {}) as IOpenBankingSpecificParams;
        if(openBakingSpecificParams.url) {
            this.services.casinofiedAnalytics.openAppRequest({
                correlationID: payload.correlationID,
                launchInfo: payload.launchInfo,
                appID: AppIdentifiers.OpenBanking,
            });
            const geoInfo = await getCasinofiedGeoInfoParams(this.services);
            this.services.casinofiedAnalytics.appInitRequest({
                correlationID: payload.correlationID,
                applicationContext: {
                    launchInfo: payload.launchInfo,
                    appID: AppIdentifiers.OpenBanking,
                    productPackageToID: ProductPackageToID.PAYMENTS_DEPOSIT,
                    ...getCasinofiedCommonAppContextParams(this.services)

                },
                deviceInfo: getCasinofiedDeviceInfo(this.services),
                geoInfo: geoInfo,
                userInfo: {
                    userMode: 'authenticated',
                    regulationTypeID: this.services.regulation.getRegulationCode(),
                    token: ''
                },
                messageBrokerChannels: this.services.messageBroker.channels
            });

            this.services.externalLinks.openLink({
                sourceLink: openBakingSpecificParams.url,
                view: 'window'
            })
        } else {
            this.services.logger.error(`OPEN_BANKING action didn't received the URL from ${payload.launchInfo?.sourceAppID}`);
        }
    }
}